<template>
  <div class="product">
    <div class="product-top">
      <div class="product-top-l">
        <Breadcrumb>
          <BreadcrumbItem to="/exhibition/index">首页</BreadcrumbItem>
          <BreadcrumbItem>产品管理</BreadcrumbItem>
          <BreadcrumbItem>全部产品</BreadcrumbItem>
        </Breadcrumb>
        <header class="product-top-l-title">全部产品</header>
        <p class="product-top-l-text">收集用户对产品的看法与意见</p>
      </div>
      <div v-show="exportFlag"  class="product-top-r">
        <div class="product-top-r-box" @click="exportInfo('feedbackrequest')">
          <Icon class="I1" type="icon iconfont icon-shangchuan" />
          <span class="s3">导出名单</span>
        </div>
      </div>
    </div>
    <Tabs :animated="false" @on-click="tabSwitch">
      <TabPane label="体验申请" name="request">
        <feedbackRequest ref="feedbackrequest"/>
      </TabPane>
      <!-- <TabPane label="体验报告" name="report">
        <feedbackReport />
      </TabPane> -->
      <TabPane label="产品留言" name="mes">
        <feedbackMes />
      </TabPane>
    </Tabs>
    <Contact />
  </div>
</template>
<script>
import feedbackRequest from "./components/feedback-request.vue";
// import feedbackReport from "./components/feedback-report.vue";
import feedbackMes from "./components/feedback-mes.vue";
import Contact from "@components/Contact/Contact";

export default {
  name: "exhibition-product",
  data() {
    return {
      exportFlag: true
    };
  },
  computed: {
  },
  mounted() {
  },
  methods: {
    exportInfo(name) {
      // 导出数据
      this.$refs[name].exportInfo();
    },
    tabSwitch(name) {
      if (name === 'request') {
        this.exportFlag = true;
      } else {
        this.exportFlag = false;
      }
    }
  },
  components: {
    Contact,
    feedbackRequest,
    // feedbackReport,
    feedbackMes
  }
};
</script>

<style lang="scss">
.product {
  .ivu-tabs-bar {
    margin: 0;
    background-color: #fff;
    border-color: transparent !important;
    margin-bottom: 0;
    padding-left: 33px;
  }
}
</style>
<style lang="scss" scoped>
.product {
  &-top {
    min-width: 650px;
    display: flex;
    justify-content: space-between;
    padding: 18px 25px 18px 35px;
    background-color: #fff;
    &-l {
      width: 400px;
      &-title {
        margin-top: 20px;
        font-size: 18px;
        color: #333;
        font-weight: bold;
      }
      &-text {
        font-size: 14px;
        color: #333;
        padding-top: 24px;
      }
    }
    &-r {
      height: 100%;
      display: flex;
      align-items: flex-end;
      padding-bottom: 15px;
      padding-right: 25px;
      &-box {
        width: 150px;
        height: 80px;
        border: 2px dotted #b10042;
        background-color: #ffe6e3;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin-left: 20px;
        .I1 {
          font-size: 16px;
          font-weight: bold;
          color: #b10042;
        }
        .s3 {
          font-size: 14px;
          color: #b10042;
          margin-left: 9px;
        }
      }
    }
  }
}
</style>